import { useCruiseWithRoute } from './use-cruise';

export function useMapDays() {
  const data = useCruiseWithRoute();
  const days = data?.cruise?.days;

  return days?.filter((day) => day.port?.position);
}
